// @ts-nocheck
import * as React from "react";
import { IconOffset } from "@toolkit/Framework/Types/Icon";

const DoubleChevronUp: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <g fill="currentColor" fillRule="evenodd" clipRule="evenodd">
                <path d="M12.029 3.518c.397-.002.778.154 1.06.433l5.972 5.972a1.5 1.5 0 0 1-2.12 2.12l-4.912-4.941-4.927 4.747A1.493 1.493 0 1 1 5.042 9.7l5.972-5.763a1.493 1.493 0 0 1 1.015-.419z" />
                <path d="M12.029 11.518c.397-.002.778.154 1.06.433l5.972 5.972a1.5 1.5 0 0 1-2.12 2.12l-4.912-4.941-4.927 4.747a1.493 1.493 0 1 1-2.06-2.149l5.972-5.763a1.493 1.493 0 0 1 1.015-.419z" />
            </g>
        </svg>
    );
};

export const DoubleChevronUpOffset: IconOffset = {
    vertical: 14,
    horizontal: 19,
};

export default React.memo(DoubleChevronUp);
